import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';
import { useSubmotive4Detail } from './hook';
import { Submotive4Data } from './data';
import { Submotive4ParamsHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    SUBMOTIVE4_NEW,
    SUBMOTIVE4,
    SUBMOTIVE4_EDIT,
    SUBMOTIVE4_DETAIL,
} from '../../../../../routes/paths';
import { Submotive4RegisterHistory } from './registerHistory';

export const Submotive4Detail = () => {
    const {
        submotive4,
        submotive4Historical,
        showHistorical,
        setShowHistorical,
    } = useSubmotive4Detail();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle submotivo 4"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={submotive4?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBMOTIVE4_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBMOTIVE4,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBMOTIVE4_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: SUBMOTIVE4_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(submotive4?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <Submotive4ParamsHistorical
                            historical={submotive4Historical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title=""
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <Submotive4Data data={submotive4} />
                </LayoutModule>
            </LayoutModule>
            <Submotive4RegisterHistory submotive4={submotive4} />
        </>
    );
};
